<template>
    <ViewNavBar />
    <div
        v-if="portfolioUsesRootHeaderSections"
        :class="['ufo--portfolio-page', templateSettings.theme, { home: isHomePage }]"
    >
        <div
            v-if="pageHasHeader"
            :class="['ufo--about-page', `ufo--about-page-${templateSettings.theme}`]"
        >
            <PageHeader :title="project.name" @back="navigateToPage()" />
        </div>
        <SectionLoader
            :sections="project.sections"
            :default-image-alt="''"
            :class="['ufo--about-page-sections', {'empty-list':project.sections.length < 1}]"
        />
    </div>
    <template v-else>
        <!-- Old layout -->
        <div v-if="templateSettings.theme.includes('profile_')" class="ufo--portfolio-container">
            <div class="ufo--portfolio-container">
                <div :class="['ufo--portfolio-page', 'profile-page', 'profile-subpage', templateSettings.theme, templateSettings.showProfilePicture ? 'profile--hp' : '']">
                    <div v-if="templateSettings.theme === 'profile_theme_default_old' || (templateSettings.theme !== 'profile_theme_one' && templateSettings.theme !== 'profile_theme_two')"
                         :class="['grid', 'ufo--page-hero', templateSettings.theme, {'home': isHomePage}]">
                        <div :class="['ufo--page-hero-content', templateSettings.showProfilePicture && (portfolio.image.url || user.image.url && !portfolio.image.url) ? 'has-picture' : 'no-profile-picture']">
                            <PortfolioHeroHelper />
                        </div>
                    </div>
                    <div class="ufo--page-content">
                        <GetHeroNavigation v-if="!templateSettings.theme || templateSettings.theme && templateSettings.theme.includes('profile_theme_default')" :show-home-button="true" />
                        <div :class="['ufo--about-page',
                                    'ufo--about-page-' + templateSettings.theme,
                                    portfolio.about && (portfolio.about.description || portfolio.about.image.url) ? 'legacy' : '']"
                        >
                            <PageHeader
                                v-if="templateSettings.theme.includes('theme_one') || templateSettings.theme.includes('theme_two')"
                                :title="project.name"
                                @back="navigateToPage()"
                            />
                            <div class="ufo--about-legacy-wrapper" v-if="showLegacyAboutPage()">
                                <AnimationWrapper>
                                    <template #animationContent>
                                        <div class="grid ufo--about-content">
                                            <div v-if="portfolio.about.image.url" class="about-picture">
                                                <img :src="portfolio.about.image.url" />
                                            </div>
                                            <div :class="['about-text', !portfolio.about.image.url ? 'no-pic' : '']" v-html="legacyAboutText()"></div>
                                        </div>
                                    </template>
                                </AnimationWrapper>
                            </div>
                        </div>
                        <div v-if="project.sections" class="ufo--about-content ufo--page-sections">
                            <SectionLoader :default-image-alt="''" :sections="project.sections"/>
                        </div>
                    </div>
                    <LegacyPublicPageFooter />
                </div>
            </div>
        </div>
        <!-- New Layout -->
        <div v-else
             :class="['ufo--portfolio-page', templateSettings.theme]"
        >
            <PortfolioHeroHelper />
            <div v-if="templateSettings.theme === 'theme_one' || templateSettings.theme === 'theme_two'"
                 :class="['ufo--about-page', 'ufo--about-page-' + templateSettings.theme]"
            >
                <PageHeader :title="project.name" :animated="false" @back="navigateToPage()" />
            </div>
            <div class="ufo--page-content ufo--home-page-content">
                <SectionLoader :sections="project.sections" :default-image-alt="''" :class="['ufo--about-page-sections', {'empty-list':project.sections.length < 1}]" />
            </div>
        </div>
    </template>
</template>

<script>
    import SectionLoader from "./sections/SectionLoader.vue";
    import {useHead} from "@unhead/vue";
    import PortfolioHeroHelper from "./themes/_helper/PortfolioHeroHelper.vue";
    import GetHeroNavigation from "./common/hero/GetHeroNavigation.vue";
    import LegacyPublicPageFooter from "./common/LegacyPublicPageFooter.vue";
    import AnimationWrapper from "../../common/components/AnimationWrapper.vue";
    import PageHeader from "./common/PageHeader.vue";
    import ViewNavBar from "./ViewNavBar.vue";
    import {mapGetters} from "vuex";
    import {injectCssVars} from "@/scripts/common/utilities/cssVars.js";
    import {NavigationPlacementEnum, PageTypesEnum} from "@/scripts/common/enums.js";
    import {buildPortfolioSocialHead} from "./socialHead.js";
    import {templatePreviewMixin} from "@/scripts/adminSite/aiPortfolioGenerator/templatePreviewMixin.js";
    import {getPortfolioGenerationPreviewPath} from "@/scripts/view/portfolio/generationPreview.js";

    let myPageHead = null;

    export default {
        name: "CustomPage",
        mixins: [templatePreviewMixin],
        components: {
            ViewNavBar,
            AnimationWrapper,
            PageHeader,
            GetHeroNavigation,
            LegacyPublicPageFooter, PortfolioHeroHelper, SectionLoader
        },
        beforeMount() {
           injectCssVars(this.getAllCssVars);
        },
        mounted() {
            myPageHead = useHead(() => this.headTags)
            if (window.scrollY) {window.scroll(0, 0)}
        },
        beforeUpdate() {
            if (window.scrollY) {window.scroll(0, 0)}
        },
        unmounted() {
            myPageHead?.dispose()
        },
        methods: {
            goBack() {
              this.$router.back()
            },
            navigateToPage(page) {
                const basePath = this.$route?.params?.shortId
                    ? `/${this.$route.params.shortId}`
                    : `/${this.portfolio?.shortId || ""}`;
                const targetPath = getPortfolioGenerationPreviewPath(this.$route, page)
                    || (page ? `${basePath}/${page}` : basePath);
                this.$router.push(targetPath);
            },
            showLegacyAboutPage() {
                const legacyPage = this.project.sections.length === 0
                    && this.project.type === 'about'
                    && this.portfolio.about
                    && (this.portfolio.about.description || this.portfolio.about.image.url)

                if(legacyPage) {
                    import("@/styles/layouts/_about-me-page.scss");
                }
                return legacyPage
            },
            legacyAboutText() {
                return this.portfolio.about.description.includes("rel=\"noopener noreferrer nofollow\"")
                    ? this.portfolio.about.description
                    : this.refactoredDesc
            },
        },
        computed: {
            ...mapGetters("design", ["getAllCssVars"]),
            ...mapGetters("view", ["viewData"]),
            ...mapGetters(["portfolioUsesRootHeaderSections"]),
            portfolio() {
                return this.viewData.portfolio
            },
            socialHead() {
                return buildPortfolioSocialHead({
                    portfolio: this.portfolio,
                    project: this.project,
                    user: this.user,
                    route: this.$route,
                });
            },
            headTags() {
                return this.socialHead;
            },
            project() {
                return this.viewData.project
            },
            isHomePage() {
                return this.project.type === PageTypesEnum.HOME
            },
            pageHasHeader() {
                const navPosition = this.portfolio?.portfolioNavigation?.layout?.position;
                return !this.$store.getters.isCaseStudy
                    && !this.isHomePage
                    && navPosition === NavigationPlacementEnum.UNDER_TEXT
                    && (this.templateSettings.theme.includes("theme_one") || this.templateSettings.theme.includes("theme_two"));
            },
            templateSettings() {
                return this.portfolio.templateSettings
            },
            user() {
                return this.viewData.user
            },
            settings() {
                return this.portfolio.templateSettings
            },
            refactoredDesc() {
                return this.portfolio.about.description.replace("<a href=", "<a rel=\"nofollow\" href=")
            },
            portfolioTemplate() {
                return this.portfolio.templateSettings.theme.replace("_old", "");
            },
        }
    }
</script>

<style lang="scss" scoped>
    .ufo--page-hero-content {
        position: relative;
    }

    .profile_theme_four .ufo--page-hero-content {
        position: sticky !important;
    }

    .profile_theme_default .ufo--page-hero-content {
        position: sticky;
    }

     .ufo--page-sections {
         &:not(.sidebar-layout).empty-list {
             min-height: 100vh;
             display: flex;
             flex-direction: column;
             justify-content: flex-end;
         }
     }
</style>
